export default "__VITE_ASSET__D2FjF$Ln__"